import { IRoofFaceData } from "common/records/RoofFace";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_ROOF_FACE = "@roofFaces/RECEIVE_ROOF_FACE";

export const RoofFaceActions = {
  receiveRoofFace: (roofFace: Partial<IRoofFaceData>) => createAction(RECEIVE_ROOF_FACE, { roofFace }),
};

export type RoofFaceActions = ActionsUnion<typeof RoofFaceActions>;
